/* eslint-disable react-hooks/exhaustive-deps */
import './index.scss';
import React, { useState, useEffect, useRef, Fragment } from 'react';
import { TabBar, Tabs, ListView, PullToRefresh, ActivityIndicator, Toast } from 'antd-mobile';
import { useHistory } from 'react-router';
import _ from 'lodash';
import { getDefaultCover, getApp, getUser, checkLogin } from '@/utils';
import sysConfig from '@/sysConfig';
import { dropDown } from '@/services/saas/dict';
import { list as getSchoolFamous } from '@/services/saas/schoolFamous';
import { getLiveChannels } from '@/services/saas/liveChannel';
import famousIcon from '@/images/ico_tabBar_famous.png';
import famousSelectedIcon from '@/images/ico_tabBar_famous_selected.png';
import myClassIcon from '@/images/ico_tabBar_myClass.png';
import myClassSelectedIcon from '@/images/ico_tabBar_myClass_selected.png';

const { famousSchool: defaultAvatar } = getDefaultCover();
const { preRouteUrl } = sysConfig;

const tabBarList = [
  { title: '名校列表', key: 'famousSchool', icon: famousIcon, selectedIcon: famousSelectedIcon },
  { title: '我的班级', key: 'myClass', icon: myClassIcon, selectedIcon: myClassSelectedIcon },
];

const pullToRefreshText = {
  activate: <span>开始刷新</span>,
  deactivate: <span>已取消</span>,
  release: <span>正在刷新</span>,
  finish: <span>已完成</span>,
};

const Icon = ({ url }) => (
  <em
    className="famous-tabBar-icon"
    style={{
      backgroundImage: `url("${url}")`,
    }}
  />
);

const ListWrap = (props) => {
  return <ul>{props.children}</ul>;
};

const FamousSchool = () => {
  const [schoolTypeList, setSchoolTypeList] = useState([]);
  const [schoolType, setSchoolType] = useState();
  const [famousSchool, setFamousSchool] = useState({
    pagination: {
      current: 1,
      total: 0,
      size: 8,
    },
    list: [],
    loading: false,
    hasMore: true,
  });
  const { pagination, list, loading, hasMore } = famousSchool;
  const { current, size } = pagination;
  const [draging, setDraging] = useState(false);
  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    }),
  );
  const listRef = useRef();
  const inputRef = useRef();
  const history = useHistory();

  const getSchoolType = async () => {
    const response = await dropDown({ code: 'org_secondary_classify_5' });
    if (response.success) {
      setSchoolTypeList(
        response.data.map((item, index) => {
          if (index === 0) {
            setSchoolType(item.value);
          }
          return {
            title: item.text,
            key: item.value,
          };
        }),
      );
    }
  };

  const getFamousSchool = async (page) => {
    setFamousSchool((famousSchool) => ({ ...famousSchool, loading: true, hasMore: true }));
    const response = await getSchoolFamous({
      size,
      current: page,
      primaryClassify: '5',
      secondaryClassify: schoolType,
      deptName: inputRef.current.value || undefined,
    });
    if (response.success) {
      const { current, pages, total, size, records } = response.data;
      const hasMore = current < pages;
      const dataList = current === 1 ? records : [...list, ...records];
      setTimeout(() => {
        setFamousSchool({
          pagination: {
            current: hasMore ? current + 1 : current,
            total,
            size,
          },
          list: dataList,
          loading: false,
          hasMore,
        });
        setDataSource(dataSource.cloneWithRows(dataList));
        setDraging(false);
      }, 400);
    }
  };

  const onEndReached = () => {
    if (!loading && hasMore) {
      getFamousSchool(current);
    }
  };

  useEffect(() => {
    getSchoolType();
  }, []);

  useEffect(() => {
    if (schoolType) {
      getFamousSchool(1);
    }
  }, [schoolType]);

  const row = (rowData, sectionID, rowID) => {
    const { badgeUrl, deptName, personalLiveChannelOnlineNum, schoolId } = rowData;
    return (
      <li
        className="school-item"
        key={rowID}
        onClick={() => {
          history.push(`${preRouteUrl}/prestigiousSchoolInfo/${schoolId}`);
        }}
      >
        <div className="school-item-cover">
          <img src={badgeUrl || defaultAvatar} alt="badge" />
        </div>
        <div className="school-item-info">
          <p className="name">{deptName}</p>
          <div className="statistic">
            {/* <span className="res-num">资源({0})</span> */}
            <span className="live-num">正在直播({personalLiveChannelOnlineNum || 0})</span>
          </div>
        </div>
      </li>
    );
  };

  const inputChange = useRef(
    _.debounce((value) => {
      getFamousSchool(1);
    }, 500),
  ).current;

  return (
    <div className="famous-school">
      <Tabs
        tabs={schoolTypeList}
        renderTabBar={(props) => <Tabs.DefaultTabBar {...props} page={4} />}
        page={schoolType}
        onChange={({ key }) => {
          if (key) {
            setSchoolType(key);
          }
        }}
      />
      <div className="search-bar">
        <div className="search-bar-input">
          <em className="prev-icon" />
          <input
            type="text"
            placeholder="请输入关键词搜索"
            ref={inputRef}
            onChange={(e) => {
              e.persist();
              inputChange();
            }}
          />
        </div>
      </div>
      <div className="famous-school-list">
        <ListView
          ref={listRef}
          dataSource={dataSource}
          renderFooter={() => (
            <div style={{ padding: 15, textAlign: 'center' }}>
              {hasMore ? (
                loading ? (
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ActivityIndicator animating={true} text="加载中..." />
                  </div>
                ) : (
                  '加载完成'
                )
              ) : (
                '没有更多'
              )}
            </div>
          )}
          renderBodyComponent={() => <ListWrap />}
          renderRow={row}
          className="active-list-wrap"
          pageSize={size}
          scrollRenderAheadDistance={500}
          onEndReached={onEndReached}
          onEndReachedThreshold={10}
          pullToRefresh={
            <PullToRefresh
              refreshing={draging}
              indicator={pullToRefreshText}
              onRefresh={() => {
                setDraging(true);
                getFamousSchool(1);
              }}
            />
          }
        />
      </div>
    </div>
  );
};

export const LiveChannelItem = ({
  key,
  coverUrl,
  title,
  subject,
  isLive,
  onClick,
  showIsLive = true,
}) => {
  return (
    <li className="livechannel-item" onClick={onClick}>
      <div className="livechannel-item-cover">
        <img src={coverUrl || defaultAvatar} alt="badge" />
        {isLive ? <em className="live-mark" /> : null}
      </div>
      <div className="livechannel-item-info">
        <p className="title">{title}</p>
        <p className="subject">科目：{subject}</p>
        {showIsLive ? (
          <em className={`status ${isLive ? 'ing' : ''}`}>{isLive ? '进行中' : '未开播'}</em>
        ) : null}
      </div>
    </li>
  );
};

const MyClass = () => {
  const [myClasses, setMyClasses] = useState({
    pagination: {
      current: 1,
      total: 0,
      size: 8,
    },
    list: [],
    loading: false,
    hasMore: true,
  });
  const { pagination, list, loading, hasMore } = myClasses;
  const { current, size } = pagination;
  const [draging, setDraging] = useState(false);
  const [dataSource, setDataSource] = useState(
    new ListView.DataSource({
      getRowData: (dataBlob, sectionID, rowID) => {
        return dataBlob[sectionID][rowID];
      },
      rowHasChanged: (row1, row2) => row1 !== row2,
    }),
  );
  const listRef = useRef();
  const history = useHistory();

  const onEndReached = () => {
    if (!loading && hasMore) {
      getMyClasses(current);
    }
  };

  const getMyClasses = async (page) => {
    const { appId } = getApp() || {};
    const { userId } = getUser() || {};
    setMyClasses((famousSchool) => ({ ...famousSchool, loading: true, hasMore: true }));
    const response = await getLiveChannels({
      size,
      current: page,
      sourceApp: appId,
      sourceId: userId,
    });
    if (response.success) {
      const { current, pages, total, size, records } = response.data;
      const hasMore = current < pages;
      const dataList = current === 1 ? records : [...list, ...records];
      setTimeout(() => {
        setMyClasses({
          pagination: {
            current: hasMore ? current + 1 : current,
            total,
            size,
          },
          list: dataList,
          loading: false,
          hasMore,
        });
        setDataSource(dataSource.cloneWithRows(dataList));
        setDraging(false);
      }, 400);
    } else {
      setMyClasses((myClass) => ({ ...myClass, loading: false }));
    }
  };

  useEffect(() => {
    getMyClasses(1);
  }, []);

  const row = (rowData, sectionID, rowID) => {
    const {
      coverUrl,
      activityName,
      liveChannelAttributeList,
      liveStatus,
      id,
    } = rowData;
    const subject = liveChannelAttributeList[2]
      ? liveChannelAttributeList[2].attributeValueName
      : '无';
    const isLive = liveStatus === '1';
    return (
      <Fragment key={rowID}>
        <LiveChannelItem
          coverUrl={coverUrl}
          title={activityName}
          subject={subject}
          isLive={isLive}
          onClick={() => {
            if (isLive) {
              history.push(`/apps/livePlay/liveChannel/${id}`);
            } else {
              Toast.info('直播尚未开始');
            }
          }}
        />
      </Fragment>
    );
  };

  return (
    <div className="my-classes">
      <ListView
        ref={listRef}
        dataSource={dataSource}
        renderFooter={() => (
          <div style={{ padding: 15, textAlign: 'center' }}>
            {hasMore ? (
              loading ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <ActivityIndicator animating={true} text="加载中..." />
                </div>
              ) : (
                '加载完成'
              )
            ) : (
              '没有更多'
            )}
          </div>
        )}
        renderBodyComponent={() => <ListWrap />}
        renderRow={row}
        className="active-list-wrap"
        pageSize={size}
        scrollRenderAheadDistance={500}
        onEndReached={onEndReached}
        onEndReachedThreshold={10}
        pullToRefresh={
          <PullToRefresh
            refreshing={draging}
            indicator={pullToRefreshText}
            onRefresh={() => {
              setDraging(true);
              getMyClasses(1);
            }}
          />
        }
      />
    </div>
  );
};

const PrestigiousSchool = () => {
  const [selected, setSelected] = useState('famousSchool');

  const renderCmpt = (key) => {
    switch (key) {
      case 'famousSchool':
        return selected === 'famousSchool' ? <FamousSchool /> : null;
      case 'myClass':
        return selected === 'myClass' ? <MyClass tabChange={setSelected} /> : null;
      default:
        return null;
    }
  };

  return (
    <div className="prestigious-school">
      <TabBar
        unselectedTintColor="#999"
        tintColor="#333"
        barTintColor="white"
        prerenderingSiblingsNumber={0}
      >
        {tabBarList.map((item) => (
          <TabBar.Item
            title={item.title}
            key={item.key}
            icon={<Icon url={item.icon} />}
            selectedIcon={<Icon url={item.selectedIcon} />}
            selected={item.key === selected}
            onPress={() => {
              if (item.key === 'myClass') {
                checkLogin({
                  onLogin: () => {
                    setSelected(item.key);
                  },
                });
              } else {
                setSelected(item.key);
              }
            }}
          >
            {renderCmpt(item.key)}
          </TabBar.Item>
        ))}
      </TabBar>
    </div>
  );
};

export default PrestigiousSchool;
